export const DIRECTO = 'D'
export const INDIRECTO = 'I'

export const __dictionary = {
  [DIRECTO]: {
    id: DIRECTO,
    nombre: 'DIRECTO'
  },
  [INDIRECTO]: {
    id: INDIRECTO,
    nombre: 'INDIRECTO'
  }
}

export const __array = [__dictionary[DIRECTO], __dictionary[INDIRECTO]]
